import { AUTH_URL } from './apiConfig';
import { fetchJsonWithAuth } from './authApi';

// The endpoint comes from the form's admin config (booleanSearchEndpoint), so
// this service is not tied to candidates — any module that gains a
// boolean-search route can point its own search form at it.
export async function searchBoolean(endpoint, body = {}, { limit = 10, offset = 0 } = {}) {
  if (!endpoint) throw new Error('No boolean search endpoint is configured for this form.');

  let json;
  try {
    json = await fetchJsonWithAuth(AUTH_URL, endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...body, limit, offset }),
    });
  } catch (error) {
    // A 400 carries { status:false, message, error:{ code, details } } — lift the
    // code/details so the caller can route INVALID_BOOLEAN_QUERY to the field.
    const envelope = error?.response?.error;
    if (envelope) {
      error.code = envelope.code;
      error.details = envelope.details;
      if (error.response?.message) error.message = error.response.message;
    }
    throw error;
  }

  if (json?.status === false) {
    const error = new Error(json?.message || 'Boolean search failed');
    error.code = json?.error?.code;
    error.details = json?.error?.details;
    throw error;
  }

  const data = json?.data ?? json ?? {};
  const items = Array.isArray(data.items) ? data.items : [];
  const count = data.count ?? {};
  const total = Number(count.total);

  const counts = {};
  if (Number.isFinite(Number(count.internal))) counts.internal = Number(count.internal);
  if (Number.isFinite(Number(count.dice))) counts.dice = Number(count.dice);

  return {
    rows: items,
    total: Number.isFinite(total) ? total : items.length,
    counts,
    sources: Array.isArray(data.sources) ? data.sources : [],
  };
}
